import { makeStyles } from '@material-ui/styles';
export const useStyles = makeStyles(() => ({
    root: {
        boxShadow: 'none',
    },
}));
